import useWindowSize from "./useWindowSize";
const useIsMobile = () => {
  const size = useWindowSize();
  return Number(size.width) < 960;
};
export default useIsMobile;